/* eslint-disable no-restricted-imports */
import { Box, Typography } from '@material-ui/core';

import { FormatMoney } from 'components';

import { formatFeePercentage } from '../../constants/gatewayConfig';
import { useStyles } from './styles';

export function BudgetSummary({
  totalComponents,
  totalServices,
  discountPercentage,
  discountAmount,
  subtotalValue,
  isCard,
  totalValue,
  cardFeeAmount,
  installments,
  installmentValue,
  paymentType,
  totalCost,
  gatewayFeePercentage,
}) {
  const classes = useStyles();

  return (
    <Box>
      <Typography variant='subtitle1' style={{ fontWeight: 600, marginBottom: 16 }}>
        💰 Resumo do Orçamento
      </Typography>
      <Box className={classes.resumoBox}>
        {/* Seção de Valores Base */}
        <Box marginBottom={2} paddingBottom={2} borderBottom='1px dashed #e0e0e0'>
          <Typography
            variant='caption'
            style={{
              textTransform: 'uppercase',
              fontWeight: 700,
              color: '#757575',
              letterSpacing: 0.5,
            }}
          >
            Valores Base
          </Typography>
          <Box display='flex' justifyContent='space-between' marginTop={1}>
            <Typography variant='body2' style={{ color: '#666' }}>
              Peças e Componentes
            </Typography>
            <Typography variant='body2' style={{ fontWeight: 600 }}>
              <FormatMoney>{totalComponents}</FormatMoney>
            </Typography>
          </Box>
          {discountPercentage > 0 && (
            <>
              <Box display='flex' justifyContent='space-between' marginTop={0.5}>
                <Typography variant='body2' style={{ color: '#4caf50' }}>
                  Desconto ({discountPercentage}%)
                </Typography>
                <Typography variant='body2' style={{ fontWeight: 600, color: '#4caf50' }}>
                  - <FormatMoney>{discountAmount}</FormatMoney>
                </Typography>
              </Box>
              <Box display='flex' justifyContent='space-between' marginTop={1}>
                <Typography variant='body2' style={{ color: '#666', fontWeight: 'bold' }}>
                  Peças e Componentes Líquido
                </Typography>
                <Typography variant='body2' style={{ fontWeight: 600 }}>
                  <FormatMoney>{totalComponents - discountAmount}</FormatMoney>
                </Typography>
              </Box>
            </>
          )}
          <Box display='flex' justifyContent='space-between' marginTop={0.5}>
            <Typography variant='body2' style={{ color: '#666', fontWeight: 'bold' }}>
              Serviços Adicionais
            </Typography>
            <Typography variant='body2' style={{ fontWeight: 600 }}>
              <FormatMoney>{totalServices}</FormatMoney>
            </Typography>
          </Box>
        </Box>

        {isCard && (
          <Box
            marginBottom={2}
            paddingBottom={2}
            borderBottom='1px dashed #e0e0e0'
            style={{ backgroundColor: '#fff3e0', padding: 12, borderRadius: 8 }}
          >
            <Typography
              variant='caption'
              style={{
                textTransform: 'uppercase',
                fontWeight: 700,
                color: '#f57c00',
                letterSpacing: 0.5,
              }}
            >
              💳 Pagamento com Cartão
            </Typography>
            <Box display='flex' justifyContent='space-between' marginTop={1}>
              <Typography variant='body2' style={{ color: '#666' }}>
                Valor sem taxa
              </Typography>
              <Typography variant='body2' style={{ fontWeight: 600 }}>
                <FormatMoney>{subtotalValue}</FormatMoney>
              </Typography>
            </Box>
            <Box display='flex' justifyContent='space-between' marginTop={0.5}>
              <Box display='flex' alignItems='center' gap={0.5}>
                <Typography variant='body2' style={{ color: '#f57c00' }}>
                  Taxa do cartão ({formatFeePercentage(gatewayFeePercentage)})
                </Typography>
              </Box>
              <Typography variant='body2' style={{ fontWeight: 600, color: '#f57c00' }}>
                + <FormatMoney>{cardFeeAmount}</FormatMoney>
              </Typography>
            </Box>
            <Typography
              variant='caption'
              style={{
                display: 'block',
                marginTop: 8,
                color: '#666',
                fontStyle: 'italic',
              }}
            >
              * Taxa cobrada pela operadora do cartão
            </Typography>
          </Box>
        )}

        <Box
          style={{
            backgroundColor: '#e3f2fd',
            padding: 12,
            borderRadius: 8,
            marginBottom: installments > 1 ? 12 : 0,
          }}
        >
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography
              variant='h6'
              style={{ fontWeight: 700, color: '#1565c0', fontSize: '1.1rem' }}
            >
              {isCard && installments === 1 ? 'Valor Total no Cartão' : 'Valor Total'}
            </Typography>
            <Typography
              variant='h5'
              style={{ fontWeight: 700, color: '#1565c0', fontSize: '1.4rem' }}
            >
              <FormatMoney>{totalValue}</FormatMoney>
            </Typography>
          </Box>
          {!isCard && (
            <Typography
              variant='caption'
              style={{ display: 'block', marginTop: 4, color: '#1976d2' }}
            >
              {paymentType === 'boleto' ? '📄 Pagamento via Boleto' : '🔷 Pagamento via PIX'}
            </Typography>
          )}
        </Box>

        {/* Parcelamento */}
        {installments > 1 && (
          <Box
            style={{
              backgroundColor: '#e8f5e9',
              padding: 12,
              borderRadius: 8,
            }}
          >
            <Box display='flex' justifyContent='space-between' alignItems='center'>
              <Typography
                variant='body1'
                style={{ fontWeight: 700, color: '#2e7d32', fontSize: '1rem' }}
              >
                💳 Parcelado em {installments}x
              </Typography>
              <Typography
                variant='h6'
                style={{ fontWeight: 700, color: '#2e7d32', fontSize: '1.2rem' }}
              >
                <FormatMoney>{installmentValue}</FormatMoney>
              </Typography>
            </Box>
            <Typography
              variant='caption'
              style={{ display: 'block', marginTop: 4, color: '#388e3c' }}
            >
              Valor de cada parcela
            </Typography>
          </Box>
        )}

        <Box marginTop={2} paddingTop={2} borderTop='1px solid #f5f5f5'>
          <Typography
            variant='caption'
            style={{ color: '#999', display: 'block', textAlign: 'center' }}
          >
            Custo interno: <FormatMoney>{totalCost}</FormatMoney> • Margem:{' '}
            {totalCost > 0 ? (((subtotalValue - totalCost) / subtotalValue) * 100).toFixed(1) : '0'}
            %
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
